module.exports = __webpack_public_path__ + "static/media/about-us.9d2a3671.jpg";